import { colorConstants } from 'config/colorConstants';
import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const CircleFilled = ({
    stroke = colorConstants.limeGreen,
    width = 10,
    height = 11,
}: {
    stroke?: string;
    width?: number;
    height?: number;
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.49707" width="10" height="10" rx="5" fill={stroke} />
        </svg>
    );
};

export default CircleFilled;
